import React from "react";

type RadarBackgroundProps = {
  fill: string;
  size?: number;
  sides?: number;
  style?: React.CSSProperties;
};

const RadarBackground: React.FC<RadarBackgroundProps> = ({
  fill,
  size = 469,
  sides,
  style,
}) => {
  const center = size / 2;
  const radius = center;

  const points: string[] = [];
  for (let i = 0; i < sides; i++) {
    const angle = (i / sides) * 2 * Math.PI - Math.PI / 2;
    const x = center + radius * Math.cos(angle);
    const y = center + radius * Math.sin(angle);
    points.push(`${x},${y}`);
  }

  return (
    <svg
      width={size}
      height={size}
      viewBox={`0 0 ${size} ${size}`}
      style={style}
    >
      <polygon points={points.join(" ")} fill={fill} />
    </svg>
  );
};

export default RadarBackground;
